/** API route map: URLS.Controller.ClientGuestTask */
export const ClientGuestTask = {
      Name: 'ClientGuestTask/',
      GetAllTask: 'guest-task',
      AddTask: 'add',
      UpdateTask: 'update',
      DeleteTask: 'delete',
      PatchTaskStatus: 'patch-task-status',
};
